export default __webpack_public_path__ + "static/media/qgis_demo.9a924f98.gif";